import { useSelector } from "react-redux";

import { LogItem } from "../../entities/Logger";
import AlwaysScrollBottom from "./AlwaysScrollBottom";
import { loggerModel } from "../../entities/Logger";
import { ILogItem } from "../../entities/Logger/model/LoggerTypes";

const LogMessages = () => {
  const loggerState = useSelector(loggerModel.selectLoggerState);
  const logs = loggerModel.selectLoggerLogs(loggerState) as ILogItem[];

  return (
    <div className="log-list__messages">
      {logs.map((log) => {
        return <LogItem key={log.id} log={log} />;
      })}
      <AlwaysScrollBottom />
    </div>
  );
};

export default LogMessages;
